import SvgIcon from '@mui/material/SvgIcon';
import {
  IconAlertCircle,
  IconAlertHexagon,
  IconAlertHexagonFilled,
  IconAlertTriangle,
  IconAlertTriangleFilled,
  IconArrowLeft,
  IconArrowRight,
  IconAt,
  IconBell,
  IconBook,
  IconBrandHipchat,
  IconBrandYoutube,
  IconBrowserCheck,
  IconBuilding,
  IconBuildingBank,
  IconBuildingChurch,
  IconBuildingStore,
  IconCalendarEvent,
  IconCalendarMonth,
  IconCalendarRepeat,
  IconCategory,
  IconCheck,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconCircleCheck,
  IconCircleCheckFilled,
  IconCircleFilled,
  IconCircleMinus,
  IconCirclePlus,
  IconCircleX,
  IconCircleXFilled,
  IconCircles,
  IconClick,
  IconClockEdit,
  IconClockHour4,
  IconClockPlus,
  IconCodeDots,
  IconColorSwatch,
  IconCopy,
  IconCopyCheck,
  IconCornerDownRight,
  IconCreditCard,
  IconDeviceFloppy,
  IconDeviceLandlinePhone,
  IconDeviceMobile,
  IconDialpad,
  IconDots,
  IconDotsVertical,
  IconDownload,
  IconDragDrop,
  IconEdit,
  IconEyeSearch,
  IconFileDescription,
  IconFilterCog,
  IconFolder,
  IconFolderOpen,
  IconFolderPlus,
  IconForms,
  IconGripVertical,
  IconHelp,
  IconHistoryToggle,
  IconHome,
  IconHourglassHigh,
  IconInfoCircleFilled,
  IconLayoutDashboard,
  IconLayoutGrid,
  IconLayoutSidebarLeftCollapse,
  IconLayoutSidebarLeftExpand,
  IconLogout2,
  IconMail,
  IconMessage,
  IconMessageBolt,
  IconMessageCircleQuestion,
  IconMessageCog,
  IconMessageDots,
  IconMessagePlus,
  IconMessageReport,
  IconNotebook,
  IconPencil,
  IconPhone,
  IconPhoneCall,
  IconPhoneOutgoing,
  IconPhoneX,
  IconPhotoPlus,
  IconPlayerPauseFilled,
  IconPlayerPlayFilled,
  IconPlugConnected,
  IconPlugConnectedX,
  IconProgress,
  IconProgressAlert,
  IconReceipt2,
  IconRefresh,
  IconRosetteDiscountCheck,
  IconSearch,
  IconSelector,
  IconSend,
  IconServer2,
  IconSettings,
  IconSparkles,
  IconSquare,
  IconSquareCheckFilled,
  IconSquareMinusFilled,
  IconTag,
  IconTags,
  IconTool,
  IconTrash,
  IconUser,
  IconUserCircle,
  IconUserCog,
  IconUserHexagon,
  IconUsers,
  IconUsersPlus,
  IconX,
} from '@tabler/icons-react';
import React from 'react';

import AIButton from 'assets/svg/ai-icon.svg';
import Archive from 'assets/svg/archive-icon.svg';
import CallResume from 'assets/svg/call-resume-icon.svg';
import CallTransfer from 'assets/svg/call-tansfer.svg';
import ClockFast from 'assets/svg/clock-fast.svg';
import Collapse from 'assets/svg/collapse-icon.svg';
import Mail from 'assets/svg/email-icon.svg';
import EmailOpen from 'assets/svg/email-read-icon.svg';
import Expand from 'assets/svg/expand-icon.svg';
import Inbox from 'assets/svg/inbox-icon.svg';
import Keyword from 'assets/svg/keyword-icon.svg';
import MapClock from 'assets/svg/map-clock-icon.svg';
import Reminder from 'assets/svg/notification-icon.svg';
import Notification from 'assets/svg/notification-icon.svg';
import OptIn from 'assets/svg/optin-icon.svg';
import OptOut from 'assets/svg/optout-icon.svg';
import Pending from 'assets/svg/pending-icon.svg';
import People from 'assets/svg/people-icon.svg';
import Profile from 'assets/svg/profile-icon.svg';
import QR from 'assets/svg/qr-scan-icon.svg';
import SortAsc from 'assets/svg/sort-ascending.svg';
import SortDesc from 'assets/svg/sort-descending.svg';
import Subject from 'assets/svg/subject-icon.svg';
import UnArchive from 'assets/svg/unarchive-icon.svg';
import WFReport from 'assets/svg/wf-report-icon.svg';
import Workflow from 'assets/svg/workflow-icon.svg';
import Youtube from 'assets/svg/youtube.svg';

const withSvg = (Icon) =>
  React.forwardRef((props, ref) => (
    <SvgIcon {...props} ref={ref}>
      <Icon />
    </SvgIcon>
  ));

export const BuildingIcon = withSvg(IconBuilding);
export const DragDropIcon = withSvg(IconDragDrop);
export const FileIcon = withSvg(IconFileDescription);
export const RefreshIcon = withSvg(IconRefresh);
export const PhoneXIcon = withSvg(IconPhoneX);
export const CheckIcon = withSvg(IconCheck);
export const HistoryToggleIcon = withSvg(IconHistoryToggle);
export const HostIcon = withSvg(IconServer2);
export const ClickIcon = withSvg(IconClick);
export const TextAtIcon = withSvg(IconAt);
export const MessageBoltIcon = withSvg(IconMessageBolt);
export const MessageCogIcon = withSvg(IconMessageCog);
export const ClockEditIcon = withSvg(IconClockEdit);
export const FormFieldIcon = withSvg(IconForms);
export const NoteBookIcon = withSvg(IconNotebook);
export const InvoiceIcon = withSvg(IconReceipt2);
export const SubscriptionIcon = withSvg(IconCalendarRepeat);
export const CreditCardIcon = withSvg(IconCreditCard);
export const UsersAddIcon = withSvg(IconUsersPlus);
export const SenderProfileIcon = withSvg(IconUserHexagon);
export const BrandingIcon = withSvg(IconColorSwatch);
export const CallOutgoingIcon = withSvg(IconPhoneOutgoing);
export const GridIcon = withSvg(IconLayoutGrid);
export const CirclePlusIcon = withSvg(IconCirclePlus);
export const CircleMinusIcon = withSvg(IconCircleMinus);
export const ChevronDownIcon = withSvg(IconChevronDown);
export const ChevronUpIcon = withSvg(IconChevronUp);
export const ChevronRightIcon = withSvg(IconChevronRight);
export const ChevronLeftIcon = withSvg(IconChevronLeft);
export const MessageIcon = withSvg(IconMessage);
export const DashboardIcon = withSvg(IconLayoutDashboard);
export const UserIcon = withSvg(IconUser);
export const UserCircleIcon = withSvg(IconUserCircle);
export const UsersIcon = withSvg(IconUsers);
export const ConnectIcon = withSvg(IconCircles);
export const CheckCircleIcon = withSvg(IconCircleCheck);
export const PhoneIcon = withSvg(IconPhone);
export const ToolIcon = withSvg(IconTool);
export const MarketIcon = withSvg(IconBuildingStore);
export const UserCogIcon = withSvg(IconUserCog);
export const SettingsIcon = withSvg(IconSettings);
export const CategoryIcon = withSvg(IconCategory);
export const AcademyIcon = withSvg(IconBuildingBank);
export const HelpIcon = withSvg(IconHelp);
export const MessageDotsIcon = withSvg(IconMessageDots);
export const MessageReportIcon = withSvg(IconMessageReport);
export const LiveHelpIcon = withSvg(IconBrandYoutube);
export const LogoutIcon = withSvg(IconLogout2);
export const SidebarCloseIcon = withSvg(IconLayoutSidebarLeftCollapse);
export const SidebarOpenIcon = withSvg(IconLayoutSidebarLeftExpand);
export const HomeIcon = withSvg(IconHome);
export const MessagePlusIcon = withSvg(IconMessagePlus);
export const BellIcon = withSvg(IconBell);
export const InfoCircleFilledIcon = withSvg(IconInfoCircleFilled);
export const ArrowSelectorIcon = withSvg(IconSelector);
export const CalendarMonthIcon = withSvg(IconCalendarMonth);
export const CheckboxIcon = withSvg(IconSquare);
export const CheckboxCheckedIcon = withSvg(IconSquareCheckFilled);
export const CheckboxIntermediateIcon = withSvg(IconSquareMinusFilled);
export const PencilIcon = withSvg(IconPencil);
export const MailIcon = withSvg(IconMail);
export const MobileIcon = withSvg(IconDeviceMobile);
export const CheckCircleFilledIcon = withSvg(IconCircleCheckFilled);
export const AlertHexagonIcon = withSvg(IconAlertHexagon);
export const AlertHexagonFilledIcon = withSvg(IconAlertHexagonFilled);
export const AlertTriangleFilledIcon = withSvg(IconAlertTriangleFilled);
export const CloseCircleFilledIcon = withSvg(IconCircleXFilled);
export const CloseIcon = withSvg(IconX);
export const PlayIcon = withSvg(IconPlayerPlayFilled);
export const PauseIcon = withSvg(IconPlayerPauseFilled);
export const DialpadIcon = withSvg(IconDialpad);
export const ChurchIcon = withSvg(IconBuildingChurch);
export const ArrowRightIcon = withSvg(IconArrowRight);
export const ArrowLeftIcon = withSvg(IconArrowLeft);
export const BrowserCheckIcon = withSvg(IconBrowserCheck);
export const PhoneCallIcon = withSvg(IconPhoneCall);
export const DesktopPhoneIcon = withSvg(IconDeviceLandlinePhone);
export const DownloadIcon = withSvg(IconDownload);
export const PlugConnectIcon = withSvg(IconPlugConnected);
export const PlugConnectXIcon = withSvg(IconPlugConnectedX);
export const FolderIcon = withSvg(IconFolder);
export const FolderOpenIcon = withSvg(IconFolderOpen);
export const CornerDownRightIcon = withSvg(IconCornerDownRight);
export const AddFolderIcon = withSvg(IconFolderPlus);
export const CopyIcon = withSvg(IconCopy);
export const SearchIcon = withSvg(IconSearch);
export const DatePickerIcon = withSvg(IconCalendarEvent);
export const AlertTriangleIcon = withSvg(IconAlertTriangle);
export const AlertCircleIcon = withSvg(IconAlertCircle);
export const AddTimeIcon = withSvg(IconClockPlus);
export const DeleteIcon = withSvg(IconTrash);
export const EditIcon = withSvg(IconEdit);
export const TimePickerIcon = withSvg(IconClockHour4);
export const ChatIcon = withSvg(IconBrandHipchat);
export const BookIcon = withSvg(IconBook);
export const MoreHorizontalIcon = withSvg(IconDots);
export const MoreVerticalIcon = withSvg(IconDotsVertical);
export const SendIcon = withSvg(IconSend);
export const CloseCircleIcon = withSvg(IconCircleX);
export const GroupIcon = withSvg(IconUsers);
export const PeopleIcon = withSvg(People);
export const WorkflowIcon = withSvg(Workflow);
export const QRIcon = withSvg(QR);
export const KeywordIcon = withSvg(Keyword);
export const CheckActionIcon = withSvg(IconCopyCheck);
export const FilterIcon = withSvg(IconFilterCog);
export const AIIcon = withSvg(IconSparkles);
export const MediaAddIcon = withSvg(IconPhotoPlus);
export const VariablesIcon = withSvg(IconCodeDots);
export const ProgressIcon = withSvg(IconProgress);
export const QuestionIcon = withSvg(IconMessageCircleQuestion);
export const GripVerticalIcon = withSvg(IconGripVertical);
export const CircleIcon = withSvg(IconCircleFilled);
export const SaveIcon = withSvg(IconDeviceFloppy);

export const RosetteDiscountCheckIcon = withSvg(IconRosetteDiscountCheck);
export const ProgressAlertIcon = withSvg(IconProgressAlert);
export const HourglassHighIcon = withSvg(IconHourglassHigh);
export const EyeSearchIcon = withSvg(IconEyeSearch);
export const TagsIcon = withSvg(IconTags);
export const TagIcon = withSvg(IconTag);

export const EmailIcon = withSvg(Mail);
export const ReminderIcon = withSvg(Reminder);
export const SubjectIcon = withSvg(Subject);
export const NotificationIcon = withSvg(Notification);

export const ArchiveIcon = withSvg(Archive);
export const EmailOpenIcon = withSvg(EmailOpen);
export const OptOutIcon = withSvg(OptOut);
export const OptInIcon = withSvg(OptIn);
export const ProfileIcon = withSvg(Profile);
export const UnArchiveIcon = withSvg(UnArchive);
export const SortDescIcon = withSvg(SortDesc);
export const SortAscIcon = withSvg(SortAsc);
export const InboxIcon = withSvg(Inbox);
export const PendingIcon = withSvg(Pending);
export const ExpandIcon = withSvg(Expand);
export const CollapseIcon = withSvg(Collapse);
export const YoutubeIcon = withSvg(Youtube);

export const CallTransferIcon = withSvg(CallTransfer);
export const CallResumeIcon = withSvg(CallResume);
export const WFReportIcon = withSvg(WFReport);
export const MapClockIcon = withSvg(MapClock);
export const ClockFastIcon = withSvg(ClockFast);
export const AIButtonIcon = withSvg(AIButton);
